<div class="myPurchase-dialog-container">
    <div class="myPurchase-dialog-header">
        Create RFQ Summary
    </div>
    <div class="myPurchase-dialog-content">
        <p class="paragraph-medium-regular">Please select the RFQ number that this summary will be referenced to.</p>
        <ng-select [appendTo]="'body'" style="padding-bottom: 0;" [items]="rfqNumbersData" bindLabel="value"
            appearance="outline" [(ngModel)]="selectedRFQ" placeholder="Please select an option">
        </ng-select>
    </div>
    <div class="myPurchase-dialog-actions">
        <div mat-dialog-actions>
            <app-button class="padBtn" name="Cancel" mat-dialog-close cdkFocusInitial tabindex="0"></app-button>
            <app-button class="padBtn" type="flat-button" name="Create" (click)="onCreate()"
                [disabled]="!selectedRFQ"></app-button>
        </div>
    </div>
</div>